<!-- 项目文件 -->
<template>
    <div class="w100p">
        <Header ></Header>
        <Titleimg :img="bgImg"></Titleimg>
        <div class="pt25 pb25 pl16 pr16">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    服务内容
                </span> 
            </p>
            <div class="mt20">
                <ul class="overflow w100p row1_txtc" >
                    <router-link to="/School/Smallapp" tag="li" class="disinblock minh160 w48p mt16 pt16 pb16 bordercc bradius4 textc  box ">
                        <P class="h52 "><img class="w52 h52" src="../../../public/img/img7.png" alt=""></P>
                        <p class="fs14 c333 pt12 pb10">驾校招生小程序</p>
                        <p class="lh18 pl5 pr5">
                            <span class="disblock c999 fs11">爆炸式营销提升</span>
                            <span class="disblock c999 fs11">驾校50%生源</span>
                        </p>
                    </router-link>

                    <router-link to="/School/Schoolmanage"  tag="li" class="disinblock minh160 w48p mt16 pt16 pb16 bordercc bradius4 textc  box ">
                        <P class="h52 "><img class="w47 h47" src="../../../public/img/img8.png" alt=""></P>
                        <p class="fs14 c333 pt12 pb10">驾校培训系统</p>
                        <p class="lh18 pl5 pr5">
                            <span class="disblock c999 fs11">提升驾校40%效能</span>
                            <span class="disblock c999 fs11">降低驾校30%成本</span>
                        </p>
                    </router-link>

                    <router-link to="/School/Wemedia" tag="li" class="disinblock minh160 w48p mt16 pt16 pb16 bordercc bradius4 textc  box ">
                        <P class="h52 "><img class="w50 h36" src="../../../public/img/img9.png" alt=""></p>
                        <p class="fs14 c333 pt12 pb10">自媒体运营</p>
                        <p class="lh18 pl5 pr5">
                            <span class="disblock c999 fs11">打造驾校专属多功能微信服务窗口号,实现驾校品牌升级内容</span>
                            <!-- <span class="disblock c999 fs11"></span> -->
                        </p>
                    </router-link>

                    <router-link to="/School/Schoolmanage" tag="li" class="disinblock minh160 w48p mt16 pt16 pb16 bordercc bradius4 textc  box ">
                        <P class="h52"><img class="w50 h42" src="../../../public/img/img10.png" alt=""></p>
                        <p class="fs14 c333 pt12 pb10">驾校培训系统</p>
                        <p class="lh18 pl5 pr5">
                            <span class="disblock c999 fs11">流量快速曝光</span>
                            <span class="disblock c999 fs11">拓宽驾校招生媒体渠道</span>
                        </p>
                    </router-link>
                  
                </ul>
            </div>
        </div>

        <div class="pt25  pl16 pr16 bgf6 pt26 posre pb50">
            <p class="fs16 c333 disinblock posre textc w100p flexc">
                <span class="border-bottom1">
                    最新案例
                </span>
            </p>
            <div class="mt20 ">
                <ul class=" overflow w100p row1_txtc pb20">
                    <!-- <div class="bradius8 w23p disinblock ml10 mr10 br8 baee cursor" @click="Todetail(item.id)" v-if="item.type==2"
                        v-for="(item,index) in caseList" :key="index">
                        <img class="w100p  h180"
                            :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png' ">
                        <div class="fs16 c333 lh28 pd15">
                            {{item.title}}
                        </div>
                    </div> -->
                    <li class="disinblock minh160 w48p mt16 box pb12 box-shadow22 ml2 mr2" v-if="item.type==2" v-for="(item,index) in caseList" :key="index">
                        <P class="fs0"><img class="imgauto bradius4 minh100" :src="item.image || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png' " alt=""></P>
                        <p class="fs14 c333 pt12 textl pl10 pr10 over_2"> {{item.title}} </p>
                    </li>

                   
                </ul>
            </div>
        </div>
        <Applyset></Applyset>
        <Footer></Footer>
        
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import Titleimg from '@/components/Titleimg';
    import Applyset from '@/components/Applyset';
    import $ from "jquery";
    export default {
        data() {
            return {
                bgImg: require('../../../public/img/img6.png'),
                caseList: [],

            };
        },
        components: {
            Header,
            Titleimg,
            Footer,
            Applyset
        },
        methods: {
            getNews() {
                let that = this;
                $.ajax({
                    type: "POST",
                    url: "https://www.yixueyijia.com/product/news.json",
                    dataType: "json",
                    async: false,
                    data: {
                        "class_id ": 1,
                    },
                    success: function(data) {
                        that.caseList = data.obj;
                        console.log(data.obj);
                        // that.$forceUpdate()
                        // that.$store.dispatch('Companynewsment').then(() => {
                        //     that.$store.state.CompanynewsDetail = that.caseList;
                        // });
                    },
                    error: function(data) {
                        console.log(data);
                    }
                });
            },
        },
        created() {
            this.getNews()
        },
        mounted() {

        },
    }
</script>
<style scoped>

</style>